import { gqlTagGira } from '@atlassian/jira-apollo-gira';

export const PROJECT_FRAGMENT = gqlTagGira`
    fragment jiraProjectFieldFragment on JiraProjectField {
        fieldId
        name
        project {
            id
            projectId
            name
            key
            avatar {
                large
            }
        }
    }
`;
